import { AxiosInstance } from "axios";
import { type ICore } from "./interfaces";

export function getUserShipmentsBuilder(apiClient: AxiosInstance) {
  return async function getUserShipments(): Promise<ICore.BookShipment[]> {
    const response = await apiClient.get(`/packages/shipments/physical-books/`);
    return response.data.results;
  };
}
